import React from 'react';
import { Filter, TextInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import UserAutocompleteInput from '../../../../commonComponents/UserAutocompleteInput';

const ProductOrderReportsFilter = (props) => (
  <Filter {...props}>
    <UserAutocompleteInput label="User ID" source="user_id" alwaysOn />
    <TextInput label="Outlet code" source="traffic_code" alwaysOn />
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date" source="end_date" end alwaysOn />
  </Filter>
);

export default ProductOrderReportsFilter;
